import { createContext } from 'react'
import type firebase from 'firebase/app'
import type {
  AuthSessionLifecycleState,
  AuthSessionSignOutReason,
} from './auth-session-state'

export type { AuthSessionLifecycleState, AuthSessionSignOutReason }

export interface AuthSessionContextValue {
  activateVerifiedSession(sessionId: string): Promise<void>
  readonly hasConfiguredFirebase: boolean
  readonly isAuthenticated: boolean
  readonly isResolvingSession: boolean
  readonly isSigningOutForReplacedSession: boolean
  readonly sessionSignOutReason: AuthSessionSignOutReason | null
  readonly sessionState: AuthSessionLifecycleState
  readonly user: firebase.User | null
}

export const AuthSessionContext = createContext<AuthSessionContextValue | null>(
  null,
)
